<ng-container>
  <ng-container>
    <div class="butonera">
      <button type="button" (click)="createTicket()" mat-stroked-button class="btn btn-warning btn-circle btn-lg p-0">
        <mat-icon class="mat-icon-add-custom">add</mat-icon>
      </button>
      <button mat-stroked-button (click)="total()" class="mb-3 mb-md-0">Totalizar</button>
    </div>
    <div class="tableTitle">
      <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true" [actionsTemplate]="actionsButtons"
        [hasShowQr]="false" [hasMonthFilter]="true" [hasHeaderActions]="true"
        [headerActionsTemplate]="headerActionsButtons" [hasSelect]="true" [showTotals]="true"
        [showTotalsHasOptionToPay]="true" [textPaided]="'Cobrado'" [textUnpaid]="'No cobrado'"
        (ticketNumberClick)="ticketNumberClick($event)" (amountNumberClick)="ticketTotalClick($event)"></app-table>
    </div>
  </ng-container>

  <ng-container *ngIf="empty">
    <div class="text-center">
      <img src="assets/icons/presupuesto.svg" class="invoiceImage">
      <p style="color: #9e9e9e">No tiene ningún ticket, presione + para crear uno.</p>
    </div>
  </ng-container>

  <ng-container *ngIf="spinner">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </ng-container>

  <ng-template #headerActionsButtons let-selected="selected">
    <ul class="custom-class">
      <li (click)="invoicePaidedSelected(selected)">
        <a>Cobrar facturas simplificadas</a>
      </li>
    </ul>
  </ng-template>

  <ng-template #actionsButtons let-uid="uid">
    <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
      <ul class="custom-class">
        <ng-container *ngIf="!row.rectifying">
          <li (click)="rectification(uid)">
            <a>
              <mat-icon>create</mat-icon> Rectificar
            </a>
          </li>
        </ng-container>
        <li *ngIf="isProjectEnable && projects?.length > 0" (click)="project(uid)">
          <a>
            <mat-icon>edit</mat-icon> Proyecto
          </a>
        </li>
        <li (click)="pdf(uid)">
          <a>
            <mat-icon>dvr</mat-icon> PDF
          </a>
        </li>
        <li (click)="pdfregalo(uid)">
          <a>
            <mat-icon>dvr</mat-icon> Ticket regalo
          </a>
        </li>
        <ng-container *ngIf="row.paided != null">
          <li (click)="invoicePaided(uid, true)">
            <a>
              <mat-icon>payment</mat-icon> Cobrada {{row.paided | date}}
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="row.paided == null && !row.rectifying">
          <li (click)="invoicePaided(uid, true)">
            <a>
              <mat-icon>payment</mat-icon> Asignar cobro
            </a>
          </li>
        </ng-container>
        <li (click)="pdfMail(uid)">
          <a>
            <mat-icon>send</mat-icon> Enviar PDF
          </a>
        </li>
        <li (click)="showMessageVerifactu(uid)">
          <a><mat-icon>info</mat-icon> Detalle verifactu</a>
        </li>
      </ul>
    </ng-container>
  </ng-template>




</ng-container>
<ng-container *ngIf="ready === false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>